import {
   StyledSubHeader,
   StyledSubHeaderControl,
   StyledSubHeaderControlContainer,
   StyledSubHeaderGroup,
   StyledSubHeaderLabel,
   StyledSubHeaderSection,
   StyledSubHeaderTabContainer
} from 'shared/styled/SubHeader.styled';
import SubHeaderTab from 'components/SubHeaderTab';
import { DateTime } from 'luxon';

interface NewIssueSubHeaderProps {
   formHasErrors: boolean;
   goToOverview: () => void;
}

const NewIssueSubHeader = ({ formHasErrors, goToOverview }: NewIssueSubHeaderProps) => {
   const displayDateTime = (): string => {
      let dateString = new Date();
      
      const dt = DateTime.fromJSDate(dateString).setLocale('gb');
      return dt.toLocaleString({...DateTime.DATETIME_MED_WITH_WEEKDAY});
   };

   return (
      <StyledSubHeader>
         <StyledSubHeaderSection style={{ maxWidth: '25%' }}>
            <StyledSubHeaderGroup>
               <StyledSubHeaderControlContainer>
                  <StyledSubHeaderLabel>Incident Date</StyledSubHeaderLabel>
                  <StyledSubHeaderControl>{displayDateTime()}</StyledSubHeaderControl>
               </StyledSubHeaderControlContainer>
            </StyledSubHeaderGroup>
            <StyledSubHeaderGroup>
               <StyledSubHeaderControlContainer>
                  <StyledSubHeaderLabel>Status</StyledSubHeaderLabel>
                  <StyledSubHeaderControl>New</StyledSubHeaderControl>
               </StyledSubHeaderControlContainer>
            </StyledSubHeaderGroup>
         </StyledSubHeaderSection>
         <StyledSubHeaderSection style={{ flex: '2 1 auto' }}>
            <StyledSubHeaderGroup style={{ justifyContent: 'flex-end' }}>
               <StyledSubHeaderTabContainer>
                  <SubHeaderTab
                     onClick={goToOverview}
                     isActive={true}
                     display={'Overview'}
                     highlightErrors={formHasErrors}
                  />
               </StyledSubHeaderTabContainer>
            </StyledSubHeaderGroup>
         </StyledSubHeaderSection>
      </StyledSubHeader>
   );
};

export default NewIssueSubHeader;
